module.exports = __webpack_public_path__ + "img/Hypoxia-BRCA_10X_Section2.2704a848.png";